module.exports = __webpack_public_path__ + "static/media/yewu-jiegou1.43f7c39a.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageBrain/yewu-jiegou1.png
// module id = 598
// module chunks = 0